<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size * 19 / 20"
    viewBox="0 0 20 19"
  >
    <g>
      <g>
        <path
          :fill="color"
          d="M18.162 2.914a.684.684 0 0 0-.743.619l-.09.993C15.79 2.113 13.123.5 10.032.5c-3.325 0-6.255 1.898-7.71 4.746a.684.684 0 1 0 1.218.622c1.23-2.41 3.703-4 6.492-4a7.283 7.283 0 0 1 6.15 3.397l-.974-.696a.684.684 0 0 0-.794 1.112l2.955 2.111a.684.684 0 0 0 1.078-.494l.332-3.641a.684.684 0 0 0-.618-.743z"
        />
        <path
          fill="none"
          :stroke="color"
          stroke-miterlimit="20"
          stroke-width=".3"
          d="M18.162 2.914a.684.684 0 0 0-.743.619l-.09.993C15.79 2.113 13.123.5 10.032.5c-3.325 0-6.255 1.898-7.71 4.746a.684.684 0 1 0 1.218.622c1.23-2.41 3.703-4 6.492-4a7.283 7.283 0 0 1 6.15 3.397l-.974-.696a.684.684 0 0 0-.794 1.112l2.955 2.111a.684.684 0 0 0 1.078-.494l.332-3.641a.684.684 0 0 0-.618-.743z"
        />
      </g>
      <g>
        <path
          :fill="color"
          d="M17.445 12.334a.684.684 0 0 0-.92.298c-1.23 2.41-3.703 4-6.492 4a7.283 7.283 0 0 1-6.15-3.397l.974.696a.684.684 0 0 0 .795-1.112l-2.956-2.111a.684.684 0 0 0-1.078.494l-.332 3.641a.684.684 0 1 0 1.362.124l.09-.993C4.275 16.387 6.942 18 10.033 18c3.325 0 6.255-1.898 7.71-4.746a.684.684 0 0 0-.298-.92z"
        />
        <path
          fill="none"
          :stroke="color"
          stroke-miterlimit="20"
          stroke-width=".3"
          d="M17.445 12.334a.684.684 0 0 0-.92.298c-1.23 2.41-3.703 4-6.492 4a7.283 7.283 0 0 1-6.15-3.397l.974.696a.684.684 0 0 0 .795-1.112l-2.956-2.111a.684.684 0 0 0-1.078.494l-.332 3.641a.684.684 0 1 0 1.362.124l.09-.993C4.275 16.387 6.942 18 10.033 18c3.325 0 6.255-1.898 7.71-4.746a.684.684 0 0 0-.298-.92z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#F6F5F8',
    },
    size: {
      type: Number,
      default: 20,
    },
  },
};
</script>
